import type { Ref } from 'vue'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { announcementCarQueryKey } from '@autobid/ui/composables/car/data/useCurrentCarAnnouncement'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { randomDebounce } from '@autobid/ui/utils/randomDebounce'
import { useQueryClient } from '@tanstack/vue-query'

export function useCurrentCarAnnouncementItemPublish() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemPublishDebounce = useState(
    'announcement-car-item-publish-debounce',
    () => ({}),
  ) as Ref<Record<number, NodeJS.Timeout>>

  const itemPublish = () => {
    startListen({
      eventName: 'premium.ITEM_PUBLISH',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId } = event.context
        clearTimeout(itemPublishDebounce.value[auctionId])

        itemPublishDebounce.value[auctionId] = randomDebounce(
          1000,
          3000,
          () => {
            const queryKey = announcementCarQueryKey.byAuctionId(auctionId)
            queryClient.invalidateQueries(queryKey)
          },
        )
      },
    })
  }

  return { itemPublish }
}
